var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"wrapper table-wrapper pa-0 ma-0"},[_c('iframe',{ref:"integratorFrame",staticClass:"integrator-frame",attrs:{"src":_vm.iframeSrc,"frameborder":"0","title":"AbrIron Integrator","allow":"clipboard-read; clipboard-write"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }